import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import {
	createYourDetails,
	getUserSettings,
	getUserPid,
} from "../../services/userService";
import { Page1 } from "./YourDetails/Page1";
import { Page2 } from "./YourDetails/Page2";

export const pathRoot = "/setupdata/yourdetails";

export const YourDetails = () => {
	const handleSaveFailure = (error) => {
		console.error(`Error saving data in ${pathRoot}: `, error);
		// history.push("/dashboard");
	};

	const [userPid, setUserPid] = useState(null);
	const [yourDetails, setYourDetails] = useState(null);

	useEffect(() => {
		setUserPid(getUserPid());

		let userDetails = getUserSettings().yourDetails;

		if (userDetails) {
		} else {
			userDetails = createYourDetails();
		}

		setYourDetails(userDetails);
	}, []);

	return (
		<>
			{userPid === null || yourDetails === null ? null : (
				<Switch>
					<Route path={`${pathRoot}/1`}>
						<Page1 userPid={userPid} yourDetails={yourDetails} />
					</Route>
					<Route path={`${pathRoot}/2`}>
						<Page2
							userPid={userPid}
							yourDetails={yourDetails}
							onSaveFailure={handleSaveFailure}
						/>
					</Route>
					<Redirect from={pathRoot} to={`${pathRoot}/1`} />
				</Switch>
			)}
		</>
	);
};
